export const PROFILE_MEDIA_LINK_TYPE_OPTIONS = [
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "twitter", label: "Twitter" },
  { value: "biodata", label: "Bio Data" },
  { value: "other", label: "Other" },
];

const PROFILE_MEDIA_LINK_TYPE_SET = new Set(
  PROFILE_MEDIA_LINK_TYPE_OPTIONS.map((option) => option.value)
);

export function normalizeProfileMediaLinkType(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return PROFILE_MEDIA_LINK_TYPE_SET.has(normalized) ? normalized : "other";
}

export function getProfileMediaLinkTypeLabel(value) {
  const normalized = normalizeProfileMediaLinkType(value);
  return (
    PROFILE_MEDIA_LINK_TYPE_OPTIONS.find((option) => option.value === normalized)?.label ||
    "Other"
  );
}

function buildCandidateUrl(value) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  return /^[a-z]+:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

function parseProfileMediaLinkUrl(value) {
  const candidate = buildCandidateUrl(value);
  if (!candidate) return null;

  try {
    const parsed = new URL(candidate);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed;
    }
  } catch (_) {
    return null;
  }

  return null;
}

export function normalizeProfileMediaLinkUrl(value) {
  const parsed = parseProfileMediaLinkUrl(value);
  return parsed ? parsed.toString() : String(value || "").trim();
}

export function isValidProfileMediaLinkUrl(value) {
  return Boolean(parseProfileMediaLinkUrl(value));
}

export function createEmptyProfileMediaLink() {
  return {
    link_type: "instagram",
    link_url: "",
  };
}

export function hasProfileMediaLinkContent(link) {
  return Boolean(String(link?.link_url || "").trim());
}

export function normalizeProfileMediaLinks(links) {
  return (Array.isArray(links) ? links : [])
    .map((link) => ({
      link_type: normalizeProfileMediaLinkType(link?.link_type),
      link_url: normalizeProfileMediaLinkUrl(link?.link_url),
    }))
    .filter((link) => hasProfileMediaLinkContent(link));
}

export function validateProfileMediaLinks(links, labelPrefix = "Link") {
  const items = Array.isArray(links) ? links : [];

  for (let index = 0; index < items.length; index += 1) {
    const link = items[index];
    const rawUrl = String(link?.link_url || "").trim();
    if (!rawUrl) continue;

    if (!isValidProfileMediaLinkUrl(rawUrl)) {
      return `${labelPrefix} #${index + 1}: Enter a valid link.`;
    }
  }

  return "";
}
